import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import { db } from "firebase/fbConfig.js";
import { connect } from "react-redux";
import compose from "recompose/compose";
import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import NotificationsIcon from "@material-ui/icons/Notifications";

class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      new: false,
      notifications: [],
    };
  }

  componentDidMount() {
    console.log("Bell mounted with: ", this.props.authUser);

    const userObserver = db
      .collection("TEST-users")
      .doc(this.props.authUser.uid)
      .onSnapshot(async (doc) => {
        const docData = {
          ...doc.data(),
          id: doc.id,
        };

        this.setState({
          new: docData.newNotifications ? true : false,
        });
      });

    this.unsubUser = userObserver;
  }

  render() {
    return (
      <Link to={"/notifications"}>
        <IconButton
          style={{
            padding: "12px 10px",
            color: this.state.new ? "red" : "",
          }}
          //   color={this.state.new ? "primary" : ""}
        >
          <NotificationsIcon />
        </IconButton>
      </Link>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
  };
};

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(Notifications);



// WEBPACK FOOTER //
// ./src/components/Notifications/index.jsx